export default __webpack_public_path__ + "static/media/help-fill.3e2df821.svg";